export default __webpack_public_path__ + "static/media/ArrowDownIcon.311185e6.svg";